import React, { useState, useRef, useEffect } from "react";

// import css
import "./Mid-Section-Pc.scss";

//import icons
import { CiEdit } from "react-icons/ci";
import { FaArrowRightLong } from "react-icons/fa6";
import { SlLogout } from "react-icons/sl";
import { RiLockPasswordFill } from "react-icons/ri";
import { CgArrowsExchangeAlt } from "react-icons/cg";

//imports for user data
import { useSelector, useDispatch } from "react-redux";

//functions for datat fetching
import {
  getProfile,
  updateTenant,
} from "../../../../redux/slices/sliceActions";

const MidSectionProfilePc = () => {
  //data fetched from the store
  const dispatch = useDispatch();
  const { user, profile } = useSelector((state) => state.landlordslice);
  const token = user?.accessToken;
  const id = user?.user?.user_id;

  const [profileUpdated, setProfileUpdated] = useState(false);

  useEffect(() => {
    console.log(user);
    dispatch(getProfile({ id, token,caretaker:true })).then((res) => {
      setProfileUpdated(true);
    });
  }, [user]);

  //input values
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);

  useEffect(() => {
    if (profileUpdated && profile.user_name) {
      const { firstName, lastName } = getFirstAndLastName(profile.user_name);
      setFirstName(firstName);
      setLastName(lastName);
      setEmail(profile.user_email || "");
      setPhoneNumber(profile.user_phone_number || "");
      setProfilePicture(profile.profile_picture || null);
    }
  }, [profileUpdated]);

  const [activeItem, setActiveItem] = useState("Profile"); // State to keep track of the active item

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  //function to handle input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "firstName":
        setFirstName(value);
        break;
      case "lastName":
        setLastName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "phoneNumber":
        setPhoneNumber(value);
        break;
      case "oldPassword":
        setOldPassword(value);
        break;
      case "newPassword":
        setNewPassword(value);
        break;
      case "confirmPassword":
        setConfirmPassword(value);
      default:
        break;
    }
  };

  const handleNavItemClick = (item) => {
    setActiveItem(item);
  };
  //profile picture
  const fileInputRef = useRef(null);
  const handleChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Handle the file (e.g., upload or display it)
      console.log("Selected file:", file);
    }
  };

  //focus
  const [focus, setFocus] = useState({}); // Track focus state

  const handleFocus = (inputName) => {
    setFocus({ ...focus, [inputName]: true });
  };

  const handleBlur = (inputName) => {
    setFocus({ ...focus, [inputName]: false });
  };

  //function to handle profile update
  const handleProfileUpdate = () => {
    console.log("Profile Updated");
  };

  return (
    <div className="profile-pc">
      <div className="left-side-profile">
        <div
          className={`choice ${activeItem === "Profile" ? "active" : ""}`}
          onClick={() => handleNavItemClick("Profile")}
        >
          <div className="icon-and-title">
            <div className="icon">
              <CiEdit fontSize={25} />
            </div>
            <div className="title">Edit Profile</div>
          </div>
          <div className="active-shape"></div>
        </div>
        <div
          className={`choice ${activeItem === "Password" ? "active" : ""}`}
          onClick={() => handleNavItemClick("Password")}
        >
          <div className="icon-and-title">
            <div className="icon">
              <RiLockPasswordFill fontSize={25} />
            </div>
            <div className="title">Change Password</div>
          </div>
          <div className="active-shape"></div>
        </div>
      </div>
      <div className="right-side-profile">
        {activeItem === "Profile" && (
          <>
            <div className="edit-profile-page">
              <div className="top-half">
                <div className="title">Edit Profile</div>
                <div className="profile-pic-container">
                  {profilePicture ? (
                    <>
                      <img
                        src={profilePicture}
                        alt="profile picture"
                        className="profile-picture"
                      />
                    </>
                  ) : (
                    <div className="profile-pic"></div>
                  )}

                  <div className="buttons-containers">
                    <div className="upload-button">
                      Change Picture
                      <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "block" }}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="upload-button">Delete Picture</div>
                  </div>
                </div>
              </div>
              <div className="bottom-half">
                <div className="fields-halves">
                  <div className="individual-half">
                    <label
                      htmlFor="first-name-input"
                      className={`text ${
                        focus["first-name-input"] ? "focus" : ""
                      }`}
                    >
                      First Name:
                    </label>
                    <input
                      type="text"
                      id="first-name-input"
                      value={firstName}
                      name="firstName"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("first-name-input")}
                      onBlur={() => handleBlur("first-name-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="individual-half">
                    <label
                      htmlFor="last-name-input"
                      className={`text ${
                        focus["last-name-input"] ? "focus" : ""
                      }`}
                    >
                      Last Name:
                    </label>
                    <input
                      type="text"
                      id="last-name-input"
                      value={lastName}
                      name="lastName"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("last-name-input")}
                      onBlur={() => handleBlur("last-name-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="email-input"
                      className={`text ${focus["email-input"] ? "focus" : ""}`}
                    >
                      email
                    </label>
                    <input
                      type="text"
                      id="email-input"
                      value={email}
                      name="email"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("email-input")}
                      onBlur={() => handleBlur("email-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="phone-number-input"
                      className={`text ${
                        focus["phone-number-input"] ? "focus" : ""
                      }`}
                    >
                      Phone Number
                    </label>
                    <input
                      type="text"
                      id="phone-number-input"
                      value={phoneNumber}
                      name="phoneNumber"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("phone-number-input")}
                      onBlur={() => handleBlur("phone-number-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className={"buttons-container "}>
                  <div
                    className="upload-button"
                    onClick={() => {
                      handleProfileUpdate();
                    }}
                  >
                    Confirm Changes
                  </div>
                  <div className="upload-button">Cancel Changes</div>
                </div>
              </div>
            </div>
          </>
        )}
        {activeItem === "Password" && (
          <>
            <div className="change-password-page">
              <div className="top-half">
                <div className="title">Change Password</div>
                <div className="sub-title">
                  Change your password by entering the old password first, then
                  the new one
                </div>
              </div>
              <div className="bottom-half">
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="old-password-input"
                      className={`text ${
                        focus["old-password-input"] ? "focus" : ""
                      }`}
                    >
                      Old Password
                    </label>
                    <input
                      type="password"
                      id="old-password-input"
                      placeholder="Enter old password"
                      name="oldPassword"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("old-password-input")}
                      onBlur={() => handleBlur("old-password-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="new-password-input"
                      className={`text ${
                        focus["new-password-input"] ? "focus" : ""
                      }`}
                    >
                      New Password
                    </label>
                    <input
                      type="password"
                      id="new-password-input"
                      placeholder="Enter new password"
                      name="newPassword"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("new-password-input")}
                      onBlur={() => handleBlur("new-password-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="fields-halves">
                  <div className={`individual-half margin-top`}>
                    <label
                      htmlFor="confirm-password-input"
                      className={`text ${
                        focus["confirm-password-input"] ? "focus" : ""
                      }`}
                    >
                      Confirm Password
                    </label>
                    <input
                      type="password"
                      id="confirm-password-input"
                      placeholder="Confirm new password"
                      name="confirmPassword"
                      className="input"
                      autoComplete="off"
                      onFocus={() => handleFocus("confirm-password-input")}
                      onBlur={() => handleBlur("confirm-password-input")}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>

                <div className={"buttons-container "}>
                  <div className="upload-button">Confirm Changes</div>
                  <div className="upload-button">Cancel Changes</div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

function getFirstAndLastName(userName) {
  // Split the user name by space to separate the first and last names
  const nameParts = userName.split(" ");

  // Check if the split array has at least two elements (first name and last name)
  if (nameParts.length >= 2) {
    const firstName = nameParts[0]; // First element is the first name
    const lastName = nameParts[1]; // Second element is the last name
    return { firstName, lastName };
  } else {
    // If the input doesn't have a last name, return null for last name
    return { firstName: nameParts[0], lastName: null };
  }
}

export default MidSectionProfilePc;
